/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Footer, Icon, Menu, Profile, CarouselNavigation } from 'components';
import { Col, Row } from 'components/Grid';
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logoSimbol from '../Logo/texel-logo-simbol.png';
import { HeaderMenu } from '@fitinsur/components';
import {
  Container,
  ContentMenu,
  ContentProfile,
  Country,
  IconNotification,
  Logo,
  Main,
  Name,
  Photo,
  Scrollbox,
  Subtitle,
  Title,
  User
} from './styles';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter, ApiNotification } from 'utils/src/index';
import logo from './connexion-logo-sqr.png';
import TopHeader from 'components/TopHeader/index';

const propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default function Layout({ children, title, subtitle, idOperation, titleButton }) {
  const authContext = useContext(GlobalAuthContext);
  const [showMenu, setShowMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [notifications, setNotifications] = useState(0);
  const [newNotifications, setNewNotifications] = useState(0);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const apiNotification = new ApiNotification();

  const [user, setUser] = useState({
    name: '',
    country: '',
    policies: 0,
    claims: 0,
    enquiries: 0,
    paymentsLate: 0,
    schedule: [
      {
        name: 'Petrobrás',
        date: 'May 15th 2020'
      },
      {
        name: 'Monsanto',
        date: 'June 1st 2020'
      }
    ],
    remember: []
  }
  );

  idOperation = !idOperation ? null : idOperation;

  async function getUserInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.sidedrawerRemember()
      .then(res => res.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          return;
        };

        const { numEnquiries, country, numClaims, numPayments, numPolices } = data.ret_value;

        setUser({ ...user, country: country?.toString() });

        setNotifications(numEnquiries + numClaims + numPayments + numPolices);
      });
  };

  useEffect(() => {
    if (authContext.status && authContext.login_response && authContext.login_response.ret_value && authContext.login_response.ret_value.firstName) {
      user.name = authContext.login_response.ret_value.firstName +
        " " + authContext.login_response.ret_value.lastName;
      user.country = authContext.user_region;
    }

    getNotificationsUnread();
    getUserInfo();
  }, []);

  const getNotificationsUnread = async () => {
    try {
      apiNotification.setAuthToken(authContext.token);
      const response = await apiNotification.getNotificationsUnread().then((response) => response.json());

      if (response.ret_code !== 200) return;

      setNewNotifications(response.ret_value);

    } catch (err) {
      console.log("getNotifications err", err)
    }
  }

  return (
    <> 
      <HeaderMenu 
          imgLogo={logoSimbol}
          user={user}
          notifications={newNotifications}
          showMenu={setShowMenu}
          showProfile={setShowProfile}
      />
      <Container style={{ paddingTop: "10px"}}>
        <ContentMenu className={showMenu ? 'menu-open' : 'menu-close'}>
          <Icon name="close" className="icon-close" onClick={() => setShowMenu(false)} />
          <Menu showProfile={setShowProfile} />
        </ContentMenu>
        <Main fullScreen={true} fullHide={true}>
          <Row>
            <Col sm={9} className="d-none d-sm-block p-0 p-md-2">
              <Title>{title}</Title>
              {!idOperation ? <Subtitle>{subtitle}</Subtitle> : <CarouselNavigation idOperation={idOperation}/>}
            </Col>
            <Col xs={12} className="d-sm-none pl-2 pr-2 p-md-3">
              <Title>{title}</Title>
              {!idOperation ? <Subtitle>{subtitle}</Subtitle> : <CarouselNavigation idOperation={idOperation} />}
            </Col>
            {titleButton && <Col>{titleButton}</Col>}
          </Row>
          <Scrollbox>
            {children}
          </Scrollbox>
        </Main>
        <ContentProfile className={showProfile ? 'profile-open' : ''}>
          <Icon name="close" className="icon-close" onClick={() => setShowProfile(false)} />
          {showProfile && <Profile user={user} />}
        </ContentProfile>
      </Container>
      <Footer />
    </>
  );
}

Layout.propTypes = propTypes;